import { useMedia } from '@/common/service/hooks/useMedia';
import { PartnersCard } from '@/entities/Partner/ui/PartnersCard';
import * as S from '../PartnersPage.style';
import { DropdownArrow } from '@/shared/images/icons/DropdownArrow';
import { useState, useEffect } from 'react';
import { IPartnersInfoDestination } from '@/common/service/api/Partners/Partners.domain';
import Link from 'next/link';
import { CardViewMore } from '../CardViewMore/CardViewMore';

export type ListProps = {
    indexItemOpen?: number;
    data: IPartnersInfoDestination[];
    openItem: (index: number, el: HTMLElement) => void;
};

export const List = ({ indexItemOpen, openItem, data }: ListProps) => {
    const [isDesktop, setIsDesctop] = useState<boolean>(false);
    const isMobileView = useMedia('(max-width: 991px)');

    useEffect(() => {
        if (!isMobileView) {
            setIsDesctop(true);
        }
    }, [isMobileView]);

    const selectedItem = data[indexItemOpen || 0];

    return (
        <>
            <S.ListContainer>
                <S.ScrollListContainer>
                    {data.map((i, index) => (
                        <div key={i.id}>
                            <S.MenuSelect
                                onClick={(e) => {
                                    openItem(index, e.target as HTMLElement);
                                }}
                                isOpen={indexItemOpen === index}
                            >
                                <S.MenuHeader isOpen={indexItemOpen === index}>
                                    <S.DestinationName>{i.name}</S.DestinationName>
                                    <S.CodeTitle>{i.state_code}</S.CodeTitle>
                                    <S.CommonDropdown isOpen={indexItemOpen === index}>
                                        <DropdownArrow />
                                    </S.CommonDropdown>
                                </S.MenuHeader>
                                <S.MobileItemsContainer isOpen={indexItemOpen === index}>
                                    {indexItemOpen === index && (
                                        <>
                                            {i.partners.slice(0, 2).map((item) => (
                                                <PartnersCard key={item.id} {...item} />
                                            ))}
                                        </>
                                    )}
                                </S.MobileItemsContainer>
                                <S.BtnWrapper>
                                    {indexItemOpen === index && i.partners.length > 2 && (
                                        <S.ButtonWrapper>
                                            <Link href={i.link} passHref>
                                                <S.Button>
                                                    <span>{`All ${i.name} Partners`}</span>
                                                </S.Button>
                                            </Link>
                                        </S.ButtonWrapper>
                                    )}
                                </S.BtnWrapper>
                            </S.MenuSelect>
                        </div>
                    ))}
                </S.ScrollListContainer>
            </S.ListContainer>
            <S.DesktopResultWrapper>
                {isDesktop && !!selectedItem && (
                    <S.ItemContainer>
                        <CardViewMore destination={selectedItem} />
                        <S.DesktopResultContainer>
                            {selectedItem.partners.slice(0, 6).map((item) => (
                                <PartnersCard key={item.id} {...item} />
                            ))}
                        </S.DesktopResultContainer>
                    </S.ItemContainer>
                )}
            </S.DesktopResultWrapper>
        </>
    );
};
